// extracted by mini-css-extract-plugin
export default {"security_notice":"security-msg_security_notice__aXyvY","security_message_container":"security-msg_security_message_container__GWfXn","rights":"security-msg_rights__iSW-y"};